import { Divider } from "@mui/material";
import { useIntl } from "react-intl";

import { Chip } from "@/components/Chip/Chip";
import { ExpandableSection } from "@/components/ExpandableSection/ExpandableSection";
import type { HotelData } from "@/features/hotels/types/types";

type Props = {
  hotel: HotelData;
};

export const HotelFacilities = ({ hotel }: Props) => {
  const intl = useIntl();

  const facilities = hotel.descriptions?.facilities?.split(",");

  if (!facilities) return null;

  return (
    <>
      <Divider
        sx={{
          borderColor: "var(--color-stroke-neutral-softer)",
          my: "calc(var(--spacing)*4)",
        }}
      />
      <div className="mb-4 font-medium text-text-tertiary">
        {intl.formatMessage({
          defaultMessage: "Facilities",
          description: "hotels.overview.facilities",
        })}
      </div>
      <ExpandableSection>
        <ul className="flex flex-wrap gap-2">
          {facilities.map((facility) => (
            <li key={facility}>
              <Chip
                label={facility}
                color="neutral-soft"
                size="medium"
                maxWidth="full"
              />
            </li>
          ))}
        </ul>
      </ExpandableSection>
    </>
  );
};
